module.exports = __webpack_public_path__ + "static/1-94535e39b8ba2c462b3c01a905a0dbc7.jpg";